/**
 * Theme presets + customizable tokens.
 * Pure data, no DOM / no storage access. Safe to import from anywhere.
 */

export const THEME_KEY = "nana-neon-theme";
export const CUSTOM_KEY = "nana-custom-theme";
export const STYLE_ID = "nana-custom-theme-style";

export const THEMES = [
  { id: "",        label: "Hồng (mặc định)", swatch: "oklch(0.65 0.28 5)" },
  { id: "cyan",    label: "Cyan",            swatch: "oklch(0.78 0.18 200)" },
  { id: "lime",    label: "Lime",            swatch: "oklch(0.85 0.22 140)" },
  { id: "violet",  label: "Tím",             swatch: "oklch(0.7 0.25 290)" },
  { id: "amber",   label: "Cam",             swatch: "oklch(0.78 0.22 60)" },
  { id: "ocean",   label: "Đại dương",       swatch: "oklch(0.7 0.18 230)" },
  { id: "sunset",  label: "Hoàng hôn",       swatch: "oklch(0.72 0.22 30)" },
  { id: "mint",    label: "Bạc hà",          swatch: "oklch(0.82 0.16 170)" },
  { id: "rose",    label: "Hồng đào",        swatch: "oklch(0.72 0.18 15)" },
  { id: "mono",    label: "Đơn sắc",         swatch: "oklch(0.75 0.02 280)" },
] as const;

/**
 * Các token có thể tự chỉnh. Mỗi token áp dụng cho cả site (public + admin)
 * vì nó nằm trên :root.
 */
export const CUSTOMIZABLE_TOKENS = [
  { key: "primary",            label: "Chính (primary)",        default: "#ff3d7a" },
  { key: "accent",             label: "Phụ (accent)",           default: "#ff6fbf" },
  { key: "background",         label: "Nền trang",              default: "#15141d" },
  { key: "foreground",         label: "Chữ chính",              default: "#f5f0f3" },
  { key: "card",               label: "Nền thẻ",                default: "#1d1b27" },
  { key: "card-foreground",    label: "Chữ trong thẻ",          default: "#f5f0f3" },
  { key: "muted",              label: "Vùng mờ",                default: "#27242f" },
  { key: "muted-foreground",   label: "Chữ vùng mờ",            default: "#a89faa" },
  { key: "border",             label: "Đường viền",             default: "#332f3c" },
  { key: "input",              label: "Nền ô nhập",             default: "#27242f" },
  { key: "ring",               label: "Vòng focus",             default: "#ff3d7a" },
  { key: "destructive",        label: "Nguy hiểm",              default: "#e8584b" },
] as const;

export type CustomToken = typeof CUSTOMIZABLE_TOKENS[number]["key"];
export type CustomMap = Partial<Record<CustomToken, string>>;
